var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPenBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-pen-blue"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-pen-blue",
    clipPath: "url(#clip-icon-pen-blue)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(-111.001 -123)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(111.001 123)",
    fill: "aqua"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_105_-_Outline",
    "data-name": "Ellipse 105 - Outline",
    d: "M10,1a9,9,0,1,0,9,9,9.01,9.01,0,0,0-9-9m0-1A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
    transform: "translate(111.001 123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen",
    "data-name": "Icon awesome-pen",
    d: "M5.844,1.875,8.417,4.448,2.829,10.036l-2.294.253A.482.482,0,0,1,0,9.756l.255-2.3L5.844,1.875Zm4.165-.383L8.8.283a.965.965,0,0,0-1.365,0L6.3,1.42,8.872,3.993l1.137-1.137a.965.965,0,0,0,0-1.365Z",
    transform: "translate(115.856 127.855)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPenBlue);
export default __webpack_public_path__ + "static/media/icon-pen-blue.85405c370fd4519790d6b04f9ffc3651.svg";
export { ForwardRef as ReactComponent };